// Reusable tool selection control for subdomain_enum dispatches.
// Used by SubdomainMonitorModal (recurring monitors) and the recon launcher
// (one-off Tools tab dispatch).

const TOOL_GROUPS = [
  {
    title: 'Passive',
    blurb: 'No traffic to target — scrapes external sources.',
    tools: [
      { value: 'subfinder', label: 'subfinder', desc: 'CT logs, threat feeds, search APIs (excludes flaky crtsh by default).' },
      { value: 'shodan', label: 'Shodan', desc: 'Shodan DNS records. Uses your Settings > API key, falls back to beacon env.' },
      { value: 'amass', label: 'amass', desc: 'Additional passive sources. Beacon must have amass installed.' },
    ],
  },
  {
    title: 'Active',
    blurb: 'Probes target DNS directly.',
    tools: [
      { value: 'dnsx', label: 'dnsx bruteforce', desc: 'Resolves <word>.<root> against system DNS using a SecLists wordlist.' },
    ],
  },
];

const WORDLIST_OPTIONS = [
  { value: 'top_5k', label: 'Top 5k (~2-5 min, daily-friendly)' },
  { value: 'top_110k', label: 'Top 110k (~30-60 min, weekly-friendly)' },
];

export default function SubdomainToolPicker({ tools, onToolsChange, wordlistSize, onWordlistSizeChange }) {
  const dnsxEnabled = tools.includes('dnsx');

  const toggle = (value) => {
    const next = new Set(tools);
    if (next.has(value)) next.delete(value); else next.add(value);
    onToolsChange(Array.from(next));
  };

  return (
    <div className="space-y-3">
      <div className="space-y-3">
        {TOOL_GROUPS.map((group) => (
          <div key={group.title} className="rounded-lg border border-cyber-300/40 p-3">
            <div className="flex items-baseline justify-between gap-2 mb-2">
              <div className="text-[11px] uppercase tracking-widest text-slate-700 font-semibold">{group.title}</div>
              <div className="text-[11px] text-slate-500">{group.blurb}</div>
            </div>
            <div className="space-y-2">
              {group.tools.map((tool) => {
                const checked = tools.includes(tool.value);
                return (
                  <label key={tool.value} className="flex items-start gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggle(tool.value)}
                      className="mt-0.5 accent-shinobi-green"
                    />
                    <span className="flex-1 min-w-0">
                      <span className="text-sm font-mono text-slate-800">{tool.label}</span>
                      <span className="block text-[11px] text-slate-500 leading-snug">{tool.desc}</span>
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {dnsxEnabled && (
        <div>
          <label className="block text-xs uppercase tracking-wider text-slate-500 mb-1">
            Wordlist (dnsx)
          </label>
          <select
            value={wordlistSize}
            onChange={(e) => onWordlistSizeChange(e.target.value)}
            className="w-full px-3 py-2 text-sm bg-cyber-100 border border-cyber-300/60 rounded-lg text-slate-900 outline-none focus:border-shinobi-green/70"
          >
            {WORDLIST_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          <p className="text-[11px] text-slate-500 mt-1">
            SecLists subdomain prefixes. Larger = thorough but slower. Default 5k is fine for daily runs.
          </p>
        </div>
      )}
    </div>
  );
}
